import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearButton"]

  connect() {
    this.hideClearButton()
  }

  fileChanged() {
    if (this.inputTarget.files && this.inputTarget.files.length > 0) {
      this.showClearButton()
    } else {
      this.hideClearButton()
    }
  }

  clearFile() {
    // Create a new input element to replace the current one
    const newInput = document.createElement('input')
    newInput.type = 'file'
    newInput.name = this.inputTarget.name
    newInput.accept = this.inputTarget.accept
    newInput.className = this.inputTarget.className
    
    // Copy data attributes
    newInput.setAttribute('data-file-upload-target', 'input')
    newInput.setAttribute('data-action', 'change->file-upload#fileChanged')
    
    // Replace the old input
    this.inputTarget.parentNode.replaceChild(newInput, this.inputTarget)
    
    // Hide the clear button
    this.hideClearButton()
  }

  showClearButton() {
    this.clearButtonTarget.style.display = 'inline-block'
  }

  hideClearButton() {
    this.clearButtonTarget.style.display = 'none'
  }
} 